import React from "react";
import { useSelector } from "react-redux";
import classes from "./Select.module.css";

const Select = ({ name, options, value, setValue,label }) => {
    const texts = useSelector(state => state.translate.texts);

    return <div className={classes.Select}>
        <label className={classes.Label}>{label}</label>
        <select className={classes.SelectInput} name={name} value={value} onChange={(e) => setValue(name, e.target.value)}>
            <option value={false}>{texts.select}</option>
            {options.map(o => <option key={o.value} value={o.value}>{o.text}</option>)}
        </select>
    </div> 

}

export default Select